import axios from "../utils/axios";
// import { toast } from "react-hot-toast";

// Get Users
export const getAllUsers = async (page = 1, per_page = 100, filters = {}) => {
    const params = { ...filters };
    if (page) params.page = page;
    if (per_page) params.per_page = per_page;

    const { data } = await axios.get(`/users`, { params });
    return data;
};

// Get Users
export const getUsers = async (id) => {
    // const { data } = await axios.get(`/users?id=${id}`);
    const { data } = await axios.get(`/users/${id}`);
    return data;
};
// Get Profile
export const getProfile = async () => {
    const { data } = await axios.get(`/auth/me`);
    return data;
};

// Create Users
export const createUsers = async (req) => {
    try {
        const { data } = await axios.post('/users', req, {
            headers: {
                'Accept': 'application/json',
            },
        });
        return data;
    } catch (error) {
        console.error("🚀 ~ createStore ~ error:", error);
        throw error;
    }
};

// update Users
export const updateUsers = async (req, id) => {
    try {
        const { data } = await axios.put(`/users/${id}`, req, {
            headers: {
                'Accept': 'application/json',
            },
        });
        return data;
    } catch (error) {
        console.error("🚀 ~ updateStore ~ error:", error);
        throw error;
    }
};

// delete Users
export const deleteUsers = async (id) => {
    try {
        const { data } = await axios.delete(`/users/${id}`, {
            headers: {
                'Accept': 'application/json',
            },
        });
        return data;
    } catch (error) {
        console.error("🚀 ~ deleteStore ~ error:", error);
        throw error;
    }
};
// delete All Users
export const deleteAllUsers = async (req) => {
    try {
        const { data } = await axios.delete('/users/mass-destroy', {
            data: req,
            headers: {
                Accept: 'application/json',
            },
        });
        return data;
    } catch (error) {
        console.error('🚀 ~ deleteAllUsers ~ error:', error);
        throw error;
    }
};

